import { Box, Heading, TextInput } from '@razorpay/blade/components';
import xGrey from 'assets/mss/x-grey.svg';
import React from 'react';
import { useSalaryStructure } from '../hooks/useSalaryStructure';
import PreviewCtcTable from './PreviewCtcTable';

export const PreviewCtc = ({ isPreviewHidden = false }: { isPreviewHidden?: boolean }) => {
  const { earningComponents, nonPayableBenefitsComponents, variableComponents } =
    useSalaryStructure();

  return (
    <Box
      borderRadius={isPreviewHidden ? 'none' : 'medium'}
      borderWidth={isPreviewHidden ? 'none' : 'thin'}
      borderColor="surface.border.gray.muted"
      backgroundImage={`url("${xGrey}")`}
      backgroundRepeat="no-repeat"
      backgroundPosition="right bottom"
      height="100%"
      overflow="auto">
      <Box
        padding="spacing.6"
        gridTemplateRows="auto auto 1fr"
        display={isPreviewHidden ? 'none' : 'grid'}>
        <Heading weight="medium">Preview with sample CTC 🔥</Heading>
        <Box position="sticky" top="spacing.0" marginY="spacing.6">
          <TextInput
            prefix="₹"
            value="1200000"
            placeholder="1200000"
            size="large"
            suffix="Per year"
            label=""
          />
        </Box>
        <Box
          overflow="auto"
          borderRadius="medium"
          borderWidth="thin"
          borderColor="surface.border.gray.muted">
          <PreviewCtcTable
            components={earningComponents}
            columnTitles={['Earning', 'Yearly Amount']}
          />
          <PreviewCtcTable components={variableComponents} columnTitles={['Component', '']} />
          <PreviewCtcTable
            components={nonPayableBenefitsComponents}
            columnTitles={['Non-payable benefits', '']}
          />
        </Box>
      </Box>
    </Box>
  );
};
